module.exports = __webpack_public_path__ + "img/20.5ad83530.png";